export default "__VITE_ASSET__3991c360__"